import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    silentUserConnectTheCall: false,
    silentObserverConnect: false,
    confirmMediateTheCall: false,
    mediate: false,
    surveyForObserver: false,
    isSkipSurveyForFirstTimeSOToMediator: false,
};

const silentObserverReducerSlice = createSlice({
    name: "silentObserverReducer",
    initialState,
    reducers: {
        setSilentUserConnectTheCall(state, action) {
            state.silentUserConnectTheCall = action.payload;
        },
        setSilentObserverConnect(state, action) {
            state.silentObserverConnect = action.payload;
        },
        setConfirmMediateTheCall(state, action) {
            state.confirmMediateTheCall = action.payload;
        },
        setMediate(state, action) {
            state.mediate = action.payload;
        },
        setSurveyForObserver(state, action) {
            state.surveyForObserver = action.payload;
        },
        setIsSkipSurveyForFirstTimeSOToMediator(state, action) {
            state.isSkipSurveyForFirstTimeSOToMediator = action.payload;
        },
        resetSilentObserverReducer() {
            return initialState;
        },
    },
});

export const {
    setSilentUserConnectTheCall,
    setSilentObserverConnect,
    setConfirmMediateTheCall,
    setMediate,
    setIsSkipSurveyForFirstTimeSOToMediator,
    setSurveyForObserver,
    resetSilentObserverReducer,
} = silentObserverReducerSlice.actions;
export default silentObserverReducerSlice.reducer;
